import { Rule } from "antd/es/form";
import { useTranslations } from "use-intl";
import { FieldsType } from "../model/types";
import { useEntityAttribute } from "@/modules/dynamic-attributes/widgets/dynamic-attributes-editor/entity-attribute-list/dynamic-attributes-context/entity-attribute-list-context";

export function useAttributeCodeInUseValidation({
  entity,
}: {
  entity?: FieldsType;
}) {
  const t = useTranslations("AttributeFormView");

  const { data } = useEntityAttribute();

  const allAttributes = [
    ...(data?.getDynamicAttributeGroupMetaInfo.attributes
      .filter((item) => item.__typename === "SimpleTypeDynamicAttributeDto")
      .map(({ attributeCode }) => attributeCode) ?? []),

    ...(data?.getDynamicAttributeGroupMetaInfo.groups.reduce(
      (result, value) => {
        return result.concat(
          value.attributes
            .filter(
              (item) => item.__typename === "SimpleTypeDynamicAttributeDto",
            )
            .map(({ attributeCode }) => attributeCode),
        );
      },
      [] as string[],
    ) ?? []),
  ];

  const attributeCodeInUseValidator: Rule = {
    message: t("This attribute code is in use"),
    validator: async (_, value) => {
      if (entity?.attributeCode === value) {
        return Promise.resolve();
      }

      if (allAttributes.includes(value)) {
        return Promise.reject();
      }

      return Promise.resolve();
    },
  };

  return {
    attributeCodeInUseValidator,
  };
}
